import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';

import { inject, observer } from 'mobx-react';
import usePrepareBanner from '../../../hooks/banner/usePrepareBanner';
import { modelOf } from '../../../prop-types';
import AdStore from '../../../store/AdStore';
import ConfigStore from '../../../store/ConfigStore';
import UIStore from '../../../store/UIStore';
import AdZones from '../../../types/AdZones';
import { resolveMainFooterBannerSlot } from '../bannerMedia';
import BannerSlider from '../BannerSlider/BannerSliderSlides';

const FooterBanner = ({ adStore, configStore, uiStore, overrideSettings }) => {
  const {
    aspectRatio,
    maximumCrossAxisSize,
    infinite,
    centerMode,
    contentJustify,
    useCreativeSlideWidth,
  } = resolveMainFooterBannerSlot({
    adZone: AdZones.FOOTER_BANNER,
    configStore,
    uiStore,
    adStore,
  });

  const getAdParameters = () => {
    return {
      bannerZones: [AdZones.FOOTER_BANNER],
    };
  };

  usePrepareBanner({
    adStore,
    searchParameters: getAdParameters(),
  });

  return (
    <BannerSlider
      className="FooterBanner"
      adZone={AdZones.FOOTER_BANNER}
      searchParams={getAdParameters()}
      aspectRatio={aspectRatio}
      maximumCrossAxisSize={maximumCrossAxisSize}
      slideContentJustify={contentJustify}
      useCreativeSlideWidth={useCreativeSlideWidth}
      overrideSettings={{
        ...overrideSettings,
        infinite,
        centerMode,
      }}
    />
  );
};

FooterBanner.propTypes = {
  adStore: modelOf(AdStore).isRequired,
  configStore: modelOf(ConfigStore).isRequired,
  uiStore: modelOf(UIStore).isRequired,
  overrideSettings: PropTypes.object,
};

export default withRouter(
  inject('adStore', 'configStore', 'uiStore')(observer(FooterBanner))
);
